// extracted by mini-css-extract-plugin
export default {"button":"n8JI16","wrapper":"FReoNS","label":"_EYQe5","bubble":"Vn7ubX"};